import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { addNotificationAction } from '../../action/notifications/notifications';

import * as Api from '../../api/api';

export const createTwilioProfileAndBrand = (accountId: number, showNotification?: boolean) =>
  createGenericDispatcher<{ errorMessage?: string }>({
    name: 'CREATE_TWILIO_PROFILE_AND_BRAND',
    loadFunction: () =>
      Api.post('/twilio-trust-hub/create-twilio-profile-and-brand', {
        body: JSON.stringify({ accountId }),
      }),
    args: { accountId },
    onSuccess: (dispatch, _getState, data) => {
      if (!data.errorMessage && showNotification) {
        dispatch(
          addNotificationAction({
            key: `create-twilio-profile-brand-${accountId}`,
            message: 'Twilio Bundle Successfully Created',
          }),
        );
      }
    },
  });
